import {
  AutomationOverallPerformanceModel,
  AutomationPerformance,
} from '../domain';
import {
  AutomationOverallPerformanceJson,
  AutomationPerformanceJson,
} from '../types';

export const automationOverallPerformanceMapper = (
  automationPerformanceJson: AutomationOverallPerformanceJson,
): AutomationOverallPerformanceModel => {
  return {
    timeSaved: {
      total: {
        value: automationPerformanceJson?.executionMetrics?.totalRunTime ?? 0,
        predicted:
          automationPerformanceJson?.executionMetrics?.totalManualDuration ?? 0,
      },
      average: {
        value: automationPerformanceJson?.executionMetrics?.averageRunTime ?? 0,
        predicted:
          automationPerformanceJson?.executionMetrics?.manualDuration ?? 0,
      },
    },
    lastRunStartDate:
      automationPerformanceJson?.executionMetrics?.lastRunStartDate,
    lastRunEndDate: automationPerformanceJson?.executionMetrics?.lastRunEndDate,
    lastRunSuccessRate: {
      successes:
        automationPerformanceJson?.executionMetrics?.lastRunTotalSuccessful ??
        0,
      businessErrors:
        automationPerformanceJson?.executionMetrics
          ?.lastRunTotalBusinessExceptions ?? 0,
      genericErrors:
        automationPerformanceJson?.executionMetrics
          ?.lastRunTotalSystemExceptions ?? 0,
    },
    devTime: {
      maintenance: automationPerformanceJson?.devTime?.maintenanceCount ?? 0,
      development: automationPerformanceJson?.devTime?.developmentCount ?? 0,
      support: automationPerformanceJson?.devTime?.supportCount ?? 0,
    },
    overallSuccessRate: {
      successes:
        automationPerformanceJson?.executionMetrics?.totalSuccessfulCases ?? 0,
      businessErrors:
        automationPerformanceJson?.executionMetrics
          ?.totalBusinessExceptionsCases ?? 0,
      genericErrors:
        automationPerformanceJson?.executionMetrics
          ?.totalSystemExceptionsCases ?? 0,
    },
    investment: {
      maintenance: automationPerformanceJson?.investment?.maintenanceCost ?? 0,
      development: automationPerformanceJson?.investment?.developmentCost ?? 0,
      infrastructure:
        automationPerformanceJson?.investment?.infrastructureCost ?? 0,
      support: automationPerformanceJson?.investment?.supportCost ?? 0,
    },
    ROI: {
      initialRoiDate: automationPerformanceJson?.roi?.initialRoiDate ?? '',
      currentRoiDate: automationPerformanceJson?.roi?.currentRoiDate ?? '',
    },
    predictedManualTime: automationPerformanceJson?.predictedManualTime ?? 0,
    automationRunTime: automationPerformanceJson?.automationRunTime ?? 0,
    totalInvestment: automationPerformanceJson?.totalInvestment ?? 0,
    totalReturn: automationPerformanceJson?.totalReturn ?? 0,
    averageCost: automationPerformanceJson?.averageCost ?? 0,
    totalExecutions: automationPerformanceJson?.totalExecutions ?? 0,
    hasJiraLink: automationPerformanceJson?.hasJiraLink ?? false,
    hasEpicId: automationPerformanceJson?.hasEpicId ?? false,
  };
};

export const automationPerformanceMapper = (
  performance: AutomationPerformanceJson,
): AutomationPerformance => ({
  automationRunTime: performance?.automationRunTime ?? 0,
  totalExecutions: performance?.totalExecutions ?? 0,
  totalReturn: performance?.totalReturn ?? 0,
  averageCost: performance?.averageCost ?? 0,
  totalInvestment: performance?.totalInvestment ?? 0,
  predictedManualTime: performance?.predictedManualTime ?? 0,
});
